module.exports = __webpack_public_path__ + "static/media/package-min.4dd38a52.png";